module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/fm.jpg",
      "width": "50%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Come in. I’m R.L. Stine. Welcome to the Goosebumps office.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hey, you’re just in time for lunch. Sit down at the table. I’m cooking up a hamster-and-cheese omelet. I know it sounds weird. But why waste a good hamster?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You don’t want that? Okay. No problem. I have some leftover chicken lips I could warm up. They don’t taste bad if you hold your nose while you swallow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Whoa. You look a little sick. Let me get you something to drink. I have some delicious bat juice. You should try it. You know, it’s very hard to squeeze the juice from a bat. They always put up such a fuss.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Well, okay, we can skip lunch. I see you are admiring the WANTED posters on the wall. Those posters show the creepiest, crawliest, grossest Goosebumps characters of all time. They are the MOST WANTED characters from the MOST WANTED books.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That poster you are studying is of a creature called The Haunter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Why do they call him The Haunter? Sammy Baker can tell you all about him. Sammy’s story began on a dark, rainy Halloween night in an old haunted house. That’s where Sammy ran into The Haunter. And that’s where his nightmares started.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Go ahead. Read Sammy’s story. You will soon find out why The Haunter is MOST WANTED.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-659a2597","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545825467_fm001.vue
// module id = 63
// module chunks = 0